import { render, staticRenderFns } from "./PlaceSidebar.vue?vue&type=template&id=0a90ab88&scoped=true&"
import script from "./PlaceSidebar.vue?vue&type=script&lang=js&"
export * from "./PlaceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PlaceSidebar.vue?vue&type=style&index=0&id=0a90ab88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90ab88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a90ab88')) {
      api.createRecord('0a90ab88', component.options)
    } else {
      api.reload('0a90ab88', component.options)
    }
    module.hot.accept("./PlaceSidebar.vue?vue&type=template&id=0a90ab88&scoped=true&", function () {
      api.rerender('0a90ab88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/shop/sidebar/PlaceSidebar.vue"
export default component.exports